export const applyform = {
    //表单对象
    x_jiguan: "", //籍贯绑定
    x_mobile: "", //手机号绑定P0105
    x_email: "", //电子邮件绑定P0105
    x_fkszd: "", //户口所在地绑定P9105
    x_changzhu: "", //常住地址绑定P9105
    x_userphoto: "", //用户照片绑定
    x_isfzjr: "", //是否复转军人
    x_zzszg: "", //是否有亲属在五粮液，页面控制使用，提交时需要轩换
    x_isfzjr_attafile: [],//是否复转军人附件
    x_idcard_attafile: [],//身份证附件
    x_internal_attafile: [],//内招人员单位证明
    x_zfctj: "",//服从岗位调剂x_zfctj_options

    upID : '',
    downID : '',
    //科研经历
    p9408 : [],

    bonus : [],
    social_attafile : [],
    zplan: "", //应聘岗位
    photo: "", //员工照片
    apgrp: "", //申请人组

    nachn: "", //姓名
    gesch: "", //性别
    gbdat: "", //出生日期
    pcode: "", //政治面貌
    icnum: "", //身份证号
    icnum_internal: "",//内招专用身份证号
    zzmzu: "", //民族
    zprov: "", //籍贯省
    zcity: "", //籍贯市
    zdist: "", //籍贯区县
    zjkzk: "", //健康状况
    zzbzh: "",//健康说明
    zzhkl: "", //户口性质
    famst: "", //婚姻状况
    zzsg: "", //身高
    zztz: "", //体重
    zhr_zzszg: "", //是否有亲属在五粮液
    zhr_dptyp: "", //关系
    zhr_dpnam: "", //亲属姓名
    zhr_zzwdw: "", //工作单位
    zfctj: "",//是否服从岗位调剂 X:是 ,'':否

    zhr_jjlxrxm: "", //紧急联系人姓名
    zhr_jjybrgx: "", //与本人关系
    zhr_jjlxrdh: "", //紧急联系方式

    x_cjrzqsx: "",//是否参加入职前实习
    zhrsxrq: "", //期望实习开始日期
    zhrrzrq: "", //期望实习结束日期

    z_aih: "", //爱好
    z_tec: "", //特长

    zldzs: "", //亮点自述

    zxxly: "", //信息来源

    famst: "", //婚姻状况
    zhr_rwrq: "", //服役时间从
    zhr_fuzrq: "", //服役时间至
    zhr_szbd: "", //部队名称

    //------内招
    zsjxm: "",//上级领导姓名
    zzw: "",//领导职务
    zlxdh: "",//领导联系方式
    zsapid: "", //自助平台工号（内招）
    pwd: "",//自助平台密码（内招)

    zzjtgs:'',
    zgsmc:'',
    zbmmc:'',
    zgwmc:'',

    //--------校招
    znjpm: "",//年级排名

    zmsd: "",//意向笔试/面试地点
    //社会关系
    p9116:[
      // {
      //   zhr_dpnam: '', 姓名
      //   zhr_dptyp: '',  关系
      //   gbdat: '',  年龄
      //   zzwdw: '',  工作单位
      //   zzwzw: '',  职务
      // }
    ],
    //教育信息
    p9100: [
        // {
        //     zhr_rxrq: '2005-09-01',//入学日期
        //     zhr_byrq: '2008-07-01',//毕业时间
        //     zhr_yxmc: '北京大学',//毕业院校
        //     zhr_zy: '',专业
        //     zhr_yjfx:'',研究方向
        //     zhr_xl: '11',学历
        //     zhr_xwdj: '',学位
        //     zhr_xz: '3',学制
        //     zhr_xxxs: '11',学习形式
        //     x_gxlb: ''高校类别
        //     zhr_syl:'' 高校类别双一流,选中打X
        //     zhr_985:''高校类别,选中打X
        //     zhr_211:''高校类别,选中打X


        // attafile,附件，上传使用
        // },

    ],
    //实习、工作履历
    p9101: [
        // {
        //     begda: '2000-01-01',开始时间
        //     endda: '2001-12-31',结束时间
        //     zhr_gzdw1: '实习单位',单位名称
        //     zhr_zwgw1: '实习岗位',岗位名称
        //     zhr_cszy1: '实习工作',岗位职责及业绩描述
        //     zhr_ygxs1: 'G',用工形式
        //     zhr_lxr: '',单位联系人
        //     zhr_dh: '',电话
        //     zhr_nsr: 0年收入
        // },
        // {
        //     begda: '2004-07-01',
        //     endda: '9999-12-31',
        //     zhr_gzdw1: '宜宾五粮液股份有限公司',
        //     zhr_zwgw1: 'IT',
        //     zhr_cszy1: '系统安装',
        //     zhr_ygxs1: 'B',
        //     zhr_lxr: '大老板',
        //     zhr_dh: '2345674321',
        //     zhr_nsr: 100.00
        // }
    ],
    //语言能力
    p9103: [
        // {
        //     zhr_wyyz: 'EN',外语语种
        //     zhr_slcd: '10',熟练程度
        //     zhr_wyjb: '112'外语等级
        //     ZHR_WYSP//外语水平
        // }
    ],
    //职业资格、专业资格合并提交sap
    p9109: [],
    //资格信息,专业、职业
    p9109_zy: [
        // {//专业技术资格
        //     zhr_zglb: '1000',资格类别=2000专业，1000=职业
        //     zhr_zghqsj: '2020-03-01',// 获取资格日期
        //     zhr_zgmc: 10400001,// 资格名称
        //     zhr_zgdj: 1,// 专业技术资格等级
        //     zhr_qdtj: '20',// 资格获取途径
        //     zhr_pzjg: ''// 批准机构
        // attafile,资格附件，上传使用
        // 资格文件
        // },
        // {
        //     zhr_zglb: '2000',
        //     zhr_zghqsj: '2018-08-08',
        //     zhr_zgmc: 20103003,
        //     zhr_zgdj: 3,
        //     zhr_qdtj: '20',
        //     zhr_pzjg: '国家鉴定中心'
        // 资格文件
        // }
    ],
    p9109_job: [
        //职业技术资格
        // {
        //     zhr_zglb: '1000',资格类别=2000专业，1000=职业
        //     zhr_zghqsj: '2020-03-01',// 获取资格日期
        //     zhr_zgmc: 10400001,// 资格名称
        //     zhr_zgdj: 1,// 专业技术资格等级
        //     zhr_qdtj: '20',// 资格获取途径
        //     zhr_pzjg: ''// 批准机构
        // attafile,资格附件，上传使用
        // 资格文件
        // },
        // {
        //     zhr_zglb: '2000',
        //     zhr_zghqsj: '2018-08-08',
        //     zhr_zgmc: 20103003,
        //     zhr_zgdj: 3,
        //     zhr_qdtj: '20',
        //     zhr_pzjg: '国家鉴定中心'
        // 资格文件
        // }
    ],
    p9109_qt:[],
    //地址信息
    p9105: [
        // {
        //     zhr_xxdz: '四川省宜宾市翠屏区象鼻街道', 地址
        //     zhr_dzlx: '9001'地址类型
        // },
        // {
        //     zhr_xxdz: '四川成都',
        //     zhr_dzlx: '9002'
        // }
    ],
    //通讯信息
    p0105: [
        // {
        //     usrty: '9003',通讯类型
        //     usrid: '13888888888' 通讯号码
        // },
        // {
        //     usrty: '9004',
        //     usrid: '123@QQ.COM'
        // }
    ],
    //附件信息
    atta: [
        // {
        //     INFTY:'9100',附件信息类型
        //     subty:'',信息子类型
        //     zatta:'/9j/4AAQSkZJRgABAQAASABIAAD/4QE0RXhpZgAATU0AKgAAAAgABgEaAAUAAAABAAAAVgEbAAUAAAABAAAAXgEoAAMAAAABAAI
        // },
        // {
        //     INFTY:'9109',
        //      subty:'',信息子类型
        //     zatta:'/9j/4AAQSkZJRgABAQAASABIAAD/4QE0RXhpZgAATU0AKgAAAAgABgEaAAUAAAABAAAAVgEbAAUAAAABAAAAXgEoAAMAAAABAAI
        // }
    ]
}

/**
 * 初始化
 */
export function initForm() {

    applyform.x_jiguan = ""; //籍贯绑定
    applyform.x_mobile = ""; //手机号绑定P0105
    applyform.x_email = ""; //电子邮件绑定P0105
    applyform.x_fkszd = ""; //户口所在地绑定P9105
    applyform.x_changzhu = ""; //常住地址绑定P9105
    applyform.x_userphoto = ""; //用户照片绑定
    applyform.upID = '';
    applyform.downID = '';
    //科研经历
    applyform.p9408 = []

    applyform.bonus = []
    applyform.social_attafile = []
    applyform.x_isfzjr = ""; //是否复转军人
    applyform.x_zzszg = ""; //是否有亲属在五粮液，页面控制使用，提交时需要轩换
    applyform.x_isfzjr_attafile = [];//是否复转军人附件
    applyform.x_idcard_attafile = []; //身份证附件
    applyform.x_internal_attafile = [];//内招单位身份证明
    applyform.x_zfctj = "";//服从岗位调剂

    applyform.zplan = ""; //应聘岗位
    applyform.photo = ""; //员工照片
    applyform.apgrp = ""; //申请人组

    applyform.nachn = ""; //姓名
    applyform.gesch = ""; //性别
    applyform.gbdat = ""; //出生日期
    applyform.pcode = ""; //政治面貌
    applyform.icnum = ""; //身份证号
    applyform.zzmzu = ""; //民族
    applyform.zprov = ""; //籍贯省
    applyform.zcity = ""; //籍贯市
    applyform.zdist = ""; //籍贯区县
    applyform.zjkzk = ""; //健康状况
    applyform.zzbzh = ""; //健康说明
    applyform.zzhkl = ""; //户口性质
    applyform.famst = ""; //婚姻状况
    applyform.zzsg = ""; //身高
    applyform.zztz = ""; //体重
    applyform.zhr_zzszg = ""; //是否有亲属在五粮液
    applyform.zhr_dptyp = ""; //关系
    applyform.zhr_dpnam = ""; //亲属姓名
    applyform.zhr_zzwdw = ""; //工作单位
    applyform.zfctj = "";//服从岗位调剂

    applyform.zhr_jjlxrxm = ""; //紧急联系人姓名
    applyform.zhr_jjybrgx = ""; //与本人关系
    applyform.zhr_jjlxrdh = ""; //紧急联系方式

    applyform.x_cjrzqsx = "";//是否参加入职前实习
    applyform.zhrsxrq = ""; //期望实习开始日期
    applyform.zhrrzrq = ""; //期望实习结束日期

    applyform.z_aih = ""; //爱好
    applyform.z_tec = ""; //特长

    applyform.zldzs = ""; //亮点自述

    applyform.zxxly = ""; //信息来源

    applyform.famst = ""; //婚姻状况
    applyform.zhr_rwrq = ""; //服役时间从
    applyform.zhr_fuzrq = ""; //服役时间至
    applyform.zhr_szbd = ""; //部队名称

    //------内招
    applyform.zsjxm = "";//上级领导姓名
    applyform.zzw = "";//领导职务
    applyform.zlxdh = "";//领导联系方式
    applyform.zsapid = ""; //自助平台工号（内招）
    applyform.pwd = ""; //自助平台密码（内招
    //--------校招
    applyform.znjpm = "";//年级排名

    applyform.zmsd = "";//意向笔试/面试地点



    //教育信息
    applyform.p9100 = [];
    //实习、工作履历
    applyform.p9101 = [];
    //语言能力
    applyform.p9103 = [];
    //职业资格、专业资格合并提交sap
    applyform.p9109 = [];
    //资格信息,专业
    applyform.p9109_zy = [];
    //职业技术资格
    applyform.p9109_job = [];
    //其他技术资格

    applyform.p9109_qt = [];


    //地址信息
    applyform.p9105 = [];
    //通讯信息
    applyform.p0105 = [];
    //附件信息
    applyform.atta = [];

}



// WEBPACK FOOTER //
// ./src/utils/applyform.js